import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Personnel } from '../model/model.personnel';
import { environment } from 'src/environments/environment';
import { Page } from '../model/model.page';

@Injectable({
  providedIn: 'root'
})
export class PersonnelService {
  basePath = environment.BasePath + "/survey";

  constructor(private httpClient: HttpClient) {}

  getPersonnel(idEtab: number, archivedPersonnel: boolean, page?: number, size?: number): Observable<Page<Personnel>> {
    const headers = new HttpHeaders().set('idEtab', idEtab.toString());
    let params = new HttpParams().set('archivedPersonnel', archivedPersonnel.toString());
    if (page !== undefined && size !== undefined) {
      params = params.set('page', page.toString()).set('size', size.toString());
    }
    return this.httpClient.get<Page<Personnel>>(`${this.basePath}/personnel`, { headers, params }).pipe(
      catchError(this.handleError)
    );
  }

  getAllPersonnelWithoutPagination(): Observable<Personnel[]> {
    const idEtab = parseInt(sessionStorage.getItem('idEtab') || '0', 10);
    const headers = new HttpHeaders().set('idEtab', idEtab.toString());
    const params = new HttpParams().set('archived', 'false');
    return this.httpClient.get<Personnel[]>(`${this.basePath}/personnel/all`, { headers, params }).pipe(
      catchError(this.handleError)
    );
  }

  getPersonnelById(id: number): Observable<Personnel> {
    return this.httpClient.get<Personnel>(`${this.basePath}/personnel/${id}`).pipe(
      catchError(this.handleError)
    );
  }

  getAllPersonnels(archivedPersonnel: boolean = false, page?: number, size?: number): Observable<Personnel[]> {
    const idEtab = parseInt(sessionStorage.getItem('idEtab') || '0', 10);
    const headers = new HttpHeaders().set('idEtab', idEtab.toString());
    let params = new HttpParams().set('archivedPersonnel', archivedPersonnel.toString());
    if (page !== undefined && size !== undefined) {
      params = params.set('page', page.toString()).set('size', size.toString());
    }
    return this.httpClient.get<Personnel[]>(`${this.basePath}/personnel`, { headers, params }).pipe(
      catchError(this.handleError)
    );
  }

  searchPersonnel(
    idEtab: number,
    nom: string,
    prenom?: string,
    cin?: string,
    telephone?: string,
    type?: string,
    email?: string,
    archivedPersonnel: boolean = false,
    page?: number,
    size?: number
  ): Observable<Page<Personnel>> {
    const headers = new HttpHeaders().set('idEtab', idEtab.toString());
    let params = new HttpParams()
      .set('nom', nom || '')
      .set('prenom', prenom || '')
      .set('cin', cin || '')
      .set('telephone', telephone || '')
      .set('email', email || '')
      .set('archivedPersonnel', archivedPersonnel.toString());
    if (type) params = params.set('type', type);
    if (page !== undefined && size !== undefined) {
      params = params.set('page', page.toString()).set('size', size.toString());
    }
    console.log('searchPersonnel params:', params.toString());
    return this.httpClient.get<Page<Personnel>>(`${this.basePath}/cherchePersonnel`, { headers, params }).pipe(
      catchError(this.handleError)
    );
  }

  getKafelPersonnel(idEtab: number): Observable<Personnel[]> {
    const headers = new HttpHeaders().set('idEtab', idEtab.toString());
    return this.httpClient.get<Personnel[]>(`${this.basePath}/chercheKafelPersonnel`, { headers }).pipe(
      catchError(this.handleError)
    );
  }

  savePersonnel(personnel: Personnel): Observable<Personnel> {
    return this.httpClient.post<Personnel>(`${this.basePath}/personnel`, personnel).pipe(
      catchError(this.handleError)
    );
  }

  editPersonnel(personnel: Personnel): Observable<Personnel> {
    return this.httpClient.put<Personnel>(`${this.basePath}/personnel/${personnel.id}`, personnel).pipe(
      catchError(this.handleError)
    );
  }

  deletePersonnel(id: number): Observable<string> {
    return this.httpClient.delete(`${this.basePath}/personnel/${id}`, { responseType: 'text' }).pipe(
      catchError(this.handleError)
    );
  }

  archivePersonnel(id: number): Observable<void> {
    return this.httpClient.put<void>(`${this.basePath}/${id}/archive`, {}).pipe(
      catchError(this.handleError)
    );
  }

  unarchivePersonnel(id: number): Observable<any> {
    return this.httpClient.put(`${this.basePath}/${id}/unarchive`, {}).pipe(
      catchError(this.handleError)
    );
  }

  resetPassword(email: string, newPassword: string): Observable<string> {
    const body = { email, newPassword };
    return this.httpClient.put(`${this.basePath}/reset-password`, body, { responseType: 'text' }).pipe(
      catchError(this.handleError)
    );
  }

  getPdfPath(personnelId: number): Observable<string> {
    return this.httpClient.get(`${this.basePath}/personnel/${personnelId}/pdf`, { responseType: 'text' }).pipe(
      catchError(this.handleError)
    );
  }

  updateStatus(personnelId: number, status: string): Observable<void> {
    return this.httpClient.put<void>(`${this.basePath}/personnel/${personnelId}/status`, { status }).pipe(
      catchError(this.handleError)
    );
  }

  hasPdf(personnelId: number): Observable<boolean> {
    return this.httpClient.get<boolean>(`${this.basePath}/personnel/${personnelId}/hasPdf`).pipe(
      catchError(this.handleError)
    );
  }

  getPersonnelByIds(ids: number[]): Observable<Personnel[]> {
    const url = `${this.basePath}/personnel/by-ids?ids=${ids.join(',')}`;
    return this.httpClient.get<Personnel[]>(url).pipe(
      catchError(this.handleError)
    );
  }

  // MÉTHODE HANDLEERROR CORRIGÉE - C'EST LA CLÉ DU PROBLÈME
  private handleError(error: HttpErrorResponse) {
    console.error('=== PERSONNEL SERVICE ERROR ===');
    console.error('Full error object:', error);
    console.error('Error status:', error.status);
    console.error('Error error:', error.error);
    console.error('Error message:', error.message);
    
    // Créer un objet d'erreur structuré
    const errorResponse: any = {
      status: error.status,
      statusText: error.statusText,
      url: error.url,
      originalError: error
    };

    // Extraire les détails de l'erreur du backend
    if (error.error) {
      if (typeof error.error === 'object') {
        // L'erreur est un objet (cas le plus courant avec Spring Boot)
        errorResponse.error = error.error;
        errorResponse.message = error.error.message || error.error.error || error.message;
        
        // Log pour debug
        console.error('Backend error object:', error.error);
        console.error('Backend error message:', error.error.message);
        console.error('Backend error type:', error.error.error);
      } else if (typeof error.error === 'string') {
        // L'erreur est une chaîne
        errorResponse.message = error.error;
        errorResponse.error = { message: error.error };
      } else {
        // Autre type
        errorResponse.message = error.message;
        errorResponse.error = { message: error.message };
      }
    } else {
      // Pas d'objet error dans la réponse
      errorResponse.message = error.message || `HTTP Error ${error.status}`;
      errorResponse.error = { message: errorResponse.message };
    }

    console.error('Structured error response:', errorResponse);
    console.error('=== END ERROR ===');
    
    // IMPORTANT: Ne pas utiliser une arrow function, retourner directement l'erreur
    return throwError(errorResponse);
  }
}